import { ISelectOption } from "components/Select/Select"
import { FilterCategory, Purpose } from "config/constants"
import { useCallback, useEffect, useState } from "react"
import AssetService from "services/AssetService"
import toastMessages from "stores/toastMessages"
import { getPurposeLabel } from "utils/utils"

export default function useAssetPurposeOptions(currentFilterCategory: FilterCategory) {
    const [options, setOptions] = useState<ISelectOption<Purpose>[] | undefined>()
    const fetchOptions = useCallback(async () => {
        try {
            const purposes = await AssetService.getAssetPurposes()
            if (!purposes) return
            setOptions(purposes.list.map(p => ({ label: getPurposeLabel(p), value: p })))
        } catch (e) {
            toastMessages.showSystemError()
        }
    }, [])

    useEffect(() => {
        if (currentFilterCategory !== FilterCategory.assetPurpose || options) return
        fetchOptions()
    }, [fetchOptions, currentFilterCategory, options])

    return {
        assetPurposeOptions: options,
    }

}
